import { JsonObject, JsonProperty } from "ta-json";

import Guard from "../guard";

@JsonObject()
export abstract class OAuthGrantBase {
    @JsonProperty("grant_type")
    abstract type: string;

    @JsonProperty("client_id")
    clientId: string;

    @JsonProperty("client_secret")
    clientSecret: string;

    constructor(clientId: string, clientSecret: string) {
        Guard.notNullOrUndefined(clientId);
        Guard.notNullOrUndefined(clientSecret);

        this.clientId = clientId;
        this.clientSecret = clientSecret;
    }
}
